import * as React from 'react'
import { get, isEqual } from 'lodash-es'

import * as workersActions from 'syft-acp-core/store/workers/actions'
import { showConfirmModal, showModal } from 'syft-acp-core/store/modals/actions'
import { store } from 'syft-acp-core/store'
import { A_VERY_LARGE_NUMBER } from '../api/call'

import './helpers.scss'
import DownloadCSVModalContent from '../components/Modal/DownloadCSVModal/DownloadCSVModalContent'
import { FormControl } from 'react-bootstrap'

export const actionDownloadCSV = (view?: string) => (resultData: Record<string, any>) => {
  const total = get(resultData, 'pagination.total', null)
  const query = resultData.query
  const hasFilters = !isEqual(resultData.query, {})
  const totalPages = Math.ceil(total / A_VERY_LARGE_NUMBER)
  let pageToDownload = 1
  let itemsInFile = pageToDownload < totalPages ? A_VERY_LARGE_NUMBER : total % A_VERY_LARGE_NUMBER

  const handlePageChange = (e: React.FormEvent<FormControl>) => {
    const evt = e.target as HTMLInputElement
    pageToDownload = Number(evt.value)
    itemsInFile = pageToDownload < totalPages ? A_VERY_LARGE_NUMBER : total % A_VERY_LARGE_NUMBER

    store.dispatch(
      showConfirmModal({
        modalConfirm: totalPages === 1 ? 'Download' : `Download page ${pageToDownload}`,
        question: formContent(itemsInFile),
        onConfirm: () => store.dispatch(workersActions.fetchWorkersCSV(query, view)),
      }),
    )
  }

  const formContent = (_itemsInFile: number) => (
    <div>
      <p>Download a CSV file with these search results?</p>
      <DownloadCSVModalContent
        hasFilters={hasFilters}
        query={query}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        pageToDownload={pageToDownload}
        total={total}
        itemsInFile={_itemsInFile}
      />
    </div>
  )

  store.dispatch(
    showConfirmModal({
      modalConfirm: totalPages === 1 ? 'Download' : `Download page ${pageToDownload}`,
      question: formContent(itemsInFile),
      onConfirm: () => store.dispatch(workersActions.fetchWorkersCSV(query, view)),
    }),
  )
}

export const actionUploadCSV = () => () => {
  store.dispatch(showModal('transferredWorkerCSVModal'))
}
